module.exports = "<div content class=\"noBalanceContainer\">\n    <div class=\"primaryMsgWrapper\">\n        <a ng-click=\"actions.onShowSecondaryMsg($event)\" class=\"questionMark\"></a>\n        <div class=\"primaryMsg\">{{ msg }}</div>\n    </div>\n    <div ng-if=\"showSecondaryMsg\" class=\"secondaryMsg\">{{ content('noBalance.secondaryMsg') }}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/no-balance/template.html
// module id = ../node_modules/xo-member-components/src/no-balance/template.html
// module chunks = 0